import {createContext} from 'react'

export const NotificationsCounterContext = createContext({})
